import { Fragment } from "react";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { useWindowSize } from "react-use";
import FooterPostup from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import style from "./Account.module.css";
import SidebarLarge from "./components/sidebar/SidebarLarge";
import SidebarSmall from "./components/sidebar/SidebarSmall";

function Account() {
  const { width } = useWindowSize();

  return (
    <Fragment>
      <Menu />
      <main
        className={"position-relative px-2 overflow-x-hidden " + style.main}
      >
        {width < 992 && <SidebarSmall />}

        <Container
          className={
            "d-flex my-5 py-4 column-gap-2 rounded-2 px-0 px-lg-2 " +
            style.container
          }
        >
          {width >= 992 && <SidebarLarge />}
          <div className={"flex-grow-1 px-3 " + style.outLet}>
            <Outlet />
          </div>
        </Container>
      </main>
      <FooterPostup />
    </Fragment>
  );
}

export default Account;
